import unknown from "payment-icons/min/flat/default.svg";
import amex from "payment-icons/min/single/amex.svg";
import diners from "payment-icons/min/single/diners.svg";
import discover from "payment-icons/min/single/discover.svg";
import jcb from "payment-icons/min/single/jcb.svg";
import unionpay from "payment-icons/min/single/unionpay.svg";
import { CreditCardIssuer } from "../issuers";
import mastercard from "./mastercard-minimal.svg";
import visa from "./visa-white.svg";

export const CreditCardIcon: Record<CreditCardIssuer, string> = {
  amex,
  diners,
  discover,
  jcb,
  mastercard,
  unionpay,
  visa,
  unknown
};
